
export enum Degree {
    NO_DIPLOMA = "C'est pas les diplômes qui comptent !",
    CAP_BEP = "CAP / BEP",
    BP = "Baccalauréat Professionnel",
    BAC_1 = "Baccalauréat",
    BAC_2 = "BTS, DEUG, DUT, DEUST (Bac+2)",
    BAC_3 = "Licence, Licence Pro, BUT (Bac+3)",
    BAC_4 = "Maîtrise, Master 1 (Bac+4)",
    BAC_5 = "Master, DESS, Ingénieur (Bac+5)",
    BAC_6 = "BAC+6",
    DOCTORATE = "Doctorat",
    CHERCHEUR = "Chercheur",
    ADDITIONAL_MENTION = "Mention complémentaire",
    // Old Version
    // TODO: Remove this after migration db
    OLD_DNB = "DNB",
    OLD_BACCALAUREAT_BP = "Baccalauréat, BP",
    OLD_DOCTORATE_BAC_5 = "Doctorat (>Bac+5)",
}

